export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫的恋爱韩漫', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', description: '魔法与冒险的奇幻世界', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', description: '热血沸腾的动作韩漫', icon: 'ri-sword-line' },
  { slug: 'thriller', name: '悬疑', description: '扣人心弦的悬疑故事', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', description: '轻松搞笑的日常韩漫', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', description: '感人至深的剧情韩漫', icon: 'ri-film-line' },
  { slug: 'horror', name: '恐怖', description: '惊悚刺激的恐怖韩漫', icon: 'ri-ghost-line' },
  { slug: 'slice-of-life', name: '日常', description: '温馨治愈的日常韩漫', icon: 'ri-home-heart-line' },
];